import { ChannelOrdersPanel } from "@/components/channel/ChannelOrdersPanel";
import { PageHeader } from "@/components/shared";

const AdminChannelOrders = () => (
  <div className="space-y-6">
    <PageHeader
      title="Channel orders"
      description="Approve or reject orders placed by distributors. Stock moves into their account only after you approve."
    />
    <ChannelOrdersPanel mode="admin" sections={["incoming"]} />
  </div>
);

export default AdminChannelOrders;
